export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_06.51cb78eb.jpg";